(function () {
    'use strict';

    var imageSliders = document.querySelectorAll('.mol-step-slider');

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }

    for (var i = 0; i < imageSliders.length; i++) {
        const nextEl = imageSliders[i].querySelector('.swiper-next');
        const prevEl = imageSliders[i].querySelector('.swiper-prev');
        const paginationEl =
            imageSliders[i].querySelector('.swiper-pagination');

        var swiperContainer =
            imageSliders[i].querySelector('.swiper');

        new Swiper(swiperContainer, {
            slidesPerView: 1.3,
            spaceBetween: 56,
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 2.3,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3.1,
                }
            },
            on: {
                afterInit: function () {
                    checkArrows(this);
                },
                resize: function () {
                    checkArrows(this);
                },
            },
        });
    }
})();
